var trigger = document.querySelector('.sw__trigger');
var gNav = document.querySelector('.g-nav');
trigger.onclick = function(){
  if(this.classList.contains("is-active")) {
    this.classList.remove("is-active");
    gNav.classList.remove("is-view");
  } else {
    this.classList.add("is-active");
    gNav.classList.add("is-view");
  }
}

var header = document.querySelector('.hd');
window.onscroll = function(){
  var rect = header.getBoundingClientRect();
  var scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
  var navPosition = rect.bottom + scrollPosition;
  if(scrollPosition > navPosition) {
    gNav.classList.add('is-fixed');
  } else {
    gNav.classList.remove('is-fixed');
  }
}
